






























































import {Component, Vue} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {卸型} from '@/type/wholesale/wholesale';
import RegisterWholesale from '@/views/wholesale/RegisterWholesale.vue';
import UpdateWholesale from '@/views/wholesale/UpdateWholesale.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import {progress} from '@/script/progress';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {viewEditingStateModule} from '@/store/state/viewEditingState';
import {発注有効区分値} from '@/type/wholesale/types';

@Component({
  filters: {
    発注有効区分を表示(発注有効区分: 発注有効区分値): string {
      return (発注有効区分 === 発注有効区分値.有効) ? 発注有効区分値.有効 : '';
    },
  },
  components: {
    RegisterForm: RegisterWholesale,
    UpdateForm: UpdateWholesale,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    NormalButton,
    AlertDialog,
  },
})
export default class ListWholesales extends Vue {

  private 卸一覧: 卸型[] = [];
  private 選択卸: 卸型 | null = null;

  private アラートメッセージ: string[] = [];

  private registerModal: boolean = false;
  private updateModal: boolean = false;

  private created(): void {
    this.show();
    viewEditingStateModule.初期化する();
  }

  private async show(): Promise<void> {
    await api.削除を含む卸一覧を取得する()
      .then((response: any) => {
        this.卸一覧 = response;
        if (this.卸一覧.length === 0) {
          this.アラートメッセージ = ['卸は存在しません'];
          this.$modal.show('アラート');
        }
      })
      .catch((error: any) => {
        this.アラートメッセージ = error.data.message;
        this.$modal.show('アラート');
      });
  }

  private select(卸: 卸型) {
    if (this.isModalOpen) {
      return;
    }
    this.選択卸 = 卸;
  }

  private reload(): void {
    this.show();
    this.選択卸 = null;
  }

  private openRegisterForm(): void {
    this.registerModal = true;
    viewEditingStateModule.画面の編集を開始する();
  }

  private closeRegisterForm(): void {
    this.reload();
    this.registerModal = false;
    viewEditingStateModule.画面の編集を終了する();
  }

  private openUpdateForm(): void {
    this.updateModal = true;
    viewEditingStateModule.画面の編集を開始する();
  }

  private get isModalOpen(): boolean {
    return this.registerModal || this.updateModal;
  }

  private async requestUpdateForm(): Promise<void>  {
    if (this.選択卸 !== null) {
      this.openUpdateForm();
    }
  }

  private closeUpdateForm(): void {
    this.reload();
    this.updateModal = false;
    viewEditingStateModule.画面の編集を終了する();
  }

  private openDeleteDialog(): void {
    this.$modal.show('deleteConfirmDialog');
  }

  private closeDeleteDialog(): void {
    this.$modal.hide('deleteConfirmDialog');
  }

  private deleteHandler(): void {
    progress(this.delete);
  }

  private async delete(): Promise<void> {
    if (this.選択卸 !== null) {
      await api.卸を削除する(this.選択卸)
        .then(
          () => {
            this.closeDeleteDialog();
            this.reload();
          },
          (error: any) => {
            this.closeDeleteDialog();
            if (error.data.errors) {
              this.アラートメッセージ = error.data.errors;
            }
            if (error.data.message && !error.data.errors) {
              this.アラートメッセージ = [error.data.message];
            }
            this.$modal.show('アラート');
          },
        );
    }
  }

  private get isDisabled(): boolean {
    return this.選択卸 === null || this.選択卸.削除フラグ === '削除';
  }
}
